import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { key: "match-to-menu", label: "Match to Menu", desc: "Read your menu into a list of items" },
  { key: "take-inventory", label: "Take Inventory", desc: "Count what you have on hand" },
  { key: "review-approve", label: "Review & Approve", desc: "Owner reviews before shopping list" },
  { key: "shopping-list", label: "Shopping List", desc: "Needs to Buy, Fully Stocked & Missing Info" },
  { key: "meal-settings", label: "Meal Settings", desc: "One-time setup for automatic meal counts" },
  { key: "photos", label: "Photos", desc: "Optional photos of each storage area" },
];

export const InventoryStepper = ({ activeStep, onStepClick }) => {
  return (
    <div data-testid="inventory-stepper" className="flex flex-wrap gap-3 mb-6 print:hidden">
      {STEPS.map((step, idx) => {
        const isActive = step.key === activeStep;
        const isEnabled = idx < 6; // all 6 steps are functional
        return (
          <button
            key={step.key}
            data-testid={`inventory-step-${step.key}`}
            disabled={!isEnabled}
            onClick={() => isEnabled && onStepClick(step.key)}
            className={`flex items-center gap-3 px-4 py-2.5 rounded-xl border-2 transition-colors text-left min-w-[180px] ${
              isActive
                ? "border-[#2F6DB5] bg-[#2F6DB5]/5"
                : isEnabled
                ? "border-slate-200 hover:border-slate-300 bg-white"
                : "border-slate-100 bg-slate-50 cursor-not-allowed opacity-60"
            }`}
          >
            <span
              className={`flex items-center justify-center w-7 h-7 rounded-full text-sm font-bold shrink-0 ${
                isActive ? "bg-[#2F6DB5] text-white" : "bg-slate-200 text-slate-600"
              }`}
            >
              {idx + 1}
            </span>
            <span>
              <span className="block text-sm font-semibold text-slate-800">{step.label}</span>
              <span className="block text-xs text-slate-500">
                {isEnabled ? step.desc : "Coming soon"}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default InventoryStepper;
